import React, { useEffect } from "react";
import { Link, Navigate } from "react-router-dom";
import { MessageCircle, ArrowLeft, Phone, CheckCircle2 } from "lucide-react";
import { buildWhatsAppLink, PHONE_TEL } from "./Siteconfig";
import useCourseSEO from "../hooks/useCourseSEO";
import RichText from "./RichText";
import "./CourseDetailView.css";
const DEFAULT_HIGHLIGHTS = [
  "Learn live",
  "Write code during class",
  "Get immediate feedback",
  "Build projects with mentor guidance",
];
export default function CourseDetailView({ course }) {
  useCourseSEO(course);
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [course]);
  if (!course) {
    return <Navigate to="/#courses" replace />;
  }
  const detail = course.detail;
  const enquiryMessage = `Hi What Next! I'm interested in the ${course.name} course. Please share batch timings and fees.`;
  const highlights = course.highlights?.length > 0 ? course.highlights : DEFAULT_HIGHLIGHTS;
  return (
    <main className="course-page">
      <div className="container course-page__inner">
        <Link to="/#courses" className="course-page__back">
          <ArrowLeft size={16} /> All Courses
        </Link>
        <header className="course-page__header">
          <span className="course-page__code">{course.code}</span>
          <h1>{course.name}</h1>
          <p className="course-page__level">{course.level}</p>
          <p className="course-page__tagline">{course.tagline}</p>
          <div className="course-page__cta">
            <a
              className="btn btn-primary"
              href={buildWhatsAppLink(enquiryMessage)}
              target="_blank"
              rel="noreferrer"
            >
              <MessageCircle size={18} /> Enquire on WhatsApp
            </a>
            <a className="btn btn-outline" href={`tel:${PHONE_TEL}`}>
              <Phone size={18} /> Talk to a Mentor
            </a>
          </div>
          <ul className="course-page__highlights">
            {highlights.map((point, i) => (
              <li key={i}>
                <CheckCircle2 size={16} />
                <span>{point}</span>
              </li>
            ))}
          </ul>
        </header>
        {detail && (
          <article className="course-page__body">
            {detail.intro?.map((paragraph, i) => (
              <RichText as="p" html={paragraph} key={i} />
            ))}
            {detail.sections?.map((section, i) => (
              <section className="course-page__section" key={i}>
                <h2>{section.heading}</h2>
                {section.paragraphs?.map((paragraph, j) => (
                  <RichText as="p" html={paragraph} key={j} />
                ))}
                {section.bullets?.length > 0 && (
                  <ul>
                    {section.bullets.map((bullet, k) => (
                      <RichText as="li" html={bullet} key={k} />
                    ))}
                  </ul>
                )}
                {section.closing && <RichText as="p" html={section.closing} />}
              </section>
            ))}
          </article>
        )}
        <div className="course-page__footer-cta">
          <h3>Ready to get started with {course.name}?</h3>
          <p>Chat with our team to know batch timings, fees, and how to enroll.</p>
          <ul className="course-page__highlights course-page__highlights--center">
            {highlights.map((point, i) => (
              <li key={i}>
                <CheckCircle2 size={16} />
                <span>{point}</span>
              </li>
            ))}
          </ul>
          <a
            className="btn btn-primary"
            href={buildWhatsAppLink(enquiryMessage)}
            target="_blank"
            rel="noreferrer"
          >
            <MessageCircle size={18} /> Enquire on WhatsApp
          </a>
        </div>
      </div>
    </main>
  );
}